/**
 * Surest Routes
 * legacy app: canActivate: [AuthGuard, VendorRoleGuard, ProviderViewGuard]
 * data: { checkRoleFor: 'UHCI_Project' }
 */

import { lazy } from 'react';
import { RouteConfig } from '../../types';

const Surest = lazy(() => import('@src/apps/Surest/Surest').then(m => ({ default: m.Surest })));

export const surestRoutes: RouteConfig[] = [
  {
    path: 'surest',
    component: Surest,
    guards: ['auth', 'vendor', 'provider'],
    data: {
      title: 'Surest',
      breadcrumb: 'Surest',
      preload: false,
      delay: false,
      checkRoleFor: 'UHCI_Project',
    },
  },
];

